export default "__VITE_ASSET__DYA$R9YS__"